const INVOICE_STATUS = {
    PENDING: 'PENDING',
    FULLY_PAYED: 'FULLY_PAYED',
    OVER_PAYED: 'OVER_PAYED',
    CANCELED: 'CANCELED',
    REFUNDED: 'REFUNDED'
}

exports = module.exports = {
    INVOICE_STATUS
}